import React from 'react';
import { Link } from 'react-router-dom';

export interface LoginPromptModalProps {
  show: boolean;
  onClose: () => void;
}

export default function LoginPromptModal({
  show,
  onClose,
}: LoginPromptModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-foreground-950/40 backdrop-blur-xs">
      <div className="bg-white rounded-3xl max-w-sm w-full p-6 text-center shadow-2xl">
        <div className="w-12 h-12 bg-primary-100 text-primary-600 rounded-full flex items-center justify-center mx-auto mb-3 text-2xl">
          <i className="ri-user-follow-line"></i>
        </div>
        <h3 className="text-lg font-bold text-foreground-950 mb-2">需要登录</h3>
        <p className="text-xs text-foreground-500 mb-6">申请岗位前请先登录您的账号</p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 border border-gray-200 rounded-xl text-xs font-medium text-foreground-600 cursor-pointer"
          >
            稍后再说
          </button>
          <Link
            to="/auth"
            className="flex-1 py-2.5 bg-primary-500 text-white rounded-xl text-xs font-medium hover:brightness-95 flex items-center justify-center cursor-pointer"
          >
            立即登录
          </Link>
        </div>
      </div>
    </div>
  );
}
